import { useTrackSelectionRedesignConfig } from "@/monarch/rules/trackSelectionRedesign/useTrackSelectionRedesign";
import { useCytMobileFirstRedesignConfig } from "@/monarch/rules/cytMobileFirstRedesign/useCytMobileFirstRedesign";

export type UseCytCurrencyConfigOptions = {
  /**
   * When false, skips Monarch fetches for trackSelectionPageRedesign and
   * cytMobileFirstRedesign. Use on non-CYT surfaces that only need CYT config
   * as a fallback when program Monarch config has no currencySelector.
   */
  enabled?: boolean;
};

export const useCytCurrencyConfig = (options?: UseCytCurrencyConfigOptions) => {
  const monarchEnabled = options?.enabled !== false;
  const track = useTrackSelectionRedesignConfig({ enabled: monarchEnabled });
  const cyt = useCytMobileFirstRedesignConfig({ enabled: monarchEnabled });

  return {
    isLoading: track.isLoading || cyt.isLoading,
    currencySelector: track.currencySelector ?? cyt.currencySelector,
    multiCurrency: track.multiCurrency ?? cyt.multiCurrency,
  };
};
